<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="$route.path != '/login'"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <v-list-item :to="{
          name: 'clients-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-account-tie</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Clientes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'users-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Utilizadores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'apps-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-android</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Aplicações</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'keys-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-key-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Chaves</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!$store.state.isUserLoggedIn" :to="{
          name: 'login'
        }">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$store.state.isUserLoggedIn" @click="logout()">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$route.path != '/login'">
          <v-icon>menu</v-icon>
        </v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Key Manager</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <p v-if="user" class="ma-2">{{user.name}}</p>
      <v-btn icon large>
        <v-avatar size="32px" tile>
          <img src="@/assets/infordio.png" alt="Infordio" />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container fluid fill-height>
        <router-view></router-view>
      </v-container>

      <v-snackbar v-model="snackbar.showing" :timeout="6000" :color="snackbar.color">
        {{snackbar.text}}
        <v-btn text @click="snackbar.showing = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapState(["snackbar", "user", "isUserLoggedIn"])
  },
  data: () => ({
    active: false,
    dialog: false,
    drawer: null
  }),
  methods: {
    logout() {
      try {
        this.$store.dispatch("setToken", null);
        this.$store.dispatch("setUser", null);
        this.$store.dispatch("setLogTime", null);
        
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error.message
        });
      }
    }
  },
  watch: {
    isUserLoggedIn(newValue) {
      if (!newValue) {
        this.$router.push({
          name: "login"
        });
      }
    }
  },beforeCreate()
  {
      this.$store.dispatch("setSnackbar", {
          showing: false,
          color: "error",
          text: ""
        });
  }
};
</script>
